import { Typography } from '@material-ui/core';
import { ColorDynamic } from '@superdispatch/ui';
import styled from 'styled-components';

const Container = styled.div`
  display: inline-block;
  margin-top: -8px;
`;

const DeclineReasonCaret = styled.div`
  right: 1px;
  bottom: -2px;
  position: relative;

  display: block;
  width: 0;
  margin-left: 24px;
  border: 8px solid transparent;
  border-bottom-color: ${ColorDynamic.Yellow50};
`;

const DeclineReasonText = styled(Typography)`
  display: block;
  padding: 8px;
  border-radius: 5px;
  background: ${ColorDynamic.Yellow50};
  word-wrap: break-word;
`;

interface PostingDeclineReasonProps {
  declineReasonText: string | null;
}

export function PostingDeclineReason({
  declineReasonText,
}: PostingDeclineReasonProps) {
  return (
    <Container aria-label="Decline reason">
      <DeclineReasonCaret />
      <DeclineReasonText>{declineReasonText}</DeclineReasonText>
    </Container>
  );
}
